import { CaseLower, CaseSensitive, CaseUpper, Underline, Strikethrough, EllipsisVertical } from 'lucide-react'

import Decoration from './Decoration'
import Transform from './Transform'

const TextDecoration = () => <>
  <div className='flex gap-1'>
    <Transform />
    <Decoration />
  </div>
</>

export function Icon({ value }) {
  const Component = ICONS[value]
  return <Component size={14} />
}

const ICONS = {
  CaseLower: CaseLower,
  CaseSensitive: CaseSensitive,
  CaseUpper: CaseUpper,
  Underline: Underline,
  Strikethrough: Strikethrough,
  EllipsisVertical: EllipsisVertical,
}

export default TextDecoration
